import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { getConsent, setConsent, onConsentChange } from "@/lib/cookieConsent";

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined;

const loadGA = () => {
  if (!GA_ID || document.getElementById("ga-script")) return;
  const s = document.createElement("script");
  s.id = "ga-script";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  const inline = document.createElement("script");
  inline.innerHTML = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${GA_ID}',{anonymize_ip:true});`;
  document.head.appendChild(inline);
};

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (c === null) setVisible(true);
    if (c === "granted") loadGA();
    return onConsentChange((v) => {
      if (v === "granted") loadGA();
      setVisible(v === null);
    });
  }, []);

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Souhlas s cookies"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-50 bg-card border border-border rounded-lg shadow-lg p-5"
    >
      <h2 className="font-serif text-lg font-semibold mb-2 text-foreground">Používáme cookies</h2>
      <p className="text-sm text-muted-foreground mb-4">
        Technicky nezbytné cookies zajišťují fungování webu. S Vaším souhlasem používáme také
        analytické cookies (Google Analytics) pro anonymní měření návštěvnosti. Více v{" "}
        <Link to="/cookies" className="underline hover:text-foreground">Zásadách cookies</Link>.
      </p>
      <div className="flex flex-col sm:flex-row gap-2">
        <Button size="sm" onClick={() => setConsent("granted")} className="flex-1">
          Přijmout vše
        </Button>
        <Button size="sm" variant="outline" onClick={() => setConsent("denied")} className="flex-1">
          Odmítnout
        </Button>
      </div>
    </div>
  );
};

export default CookieConsent;
